export const whiteBorder: any = {
  border: 'white 1px solid'
};